import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  waveformContainer: {
    width: '100%',
    display: 'flex',
    paddingLeft: 1,
    flexDirection: 'column',
    '&:focus': {
      outline: 0,
      boxShadow: 'none',
    },
  },

  waveform: {
    // [theme.breakpoints.up(900)]: { width: '95vw' },
    paddingTop: '6px',
  },
}));

export default useStyles;
